import { HelpCollection } from "@/types/help.types.ts";
import { Avatar, Box, Stack, Tag, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface Props {
  collections: HelpCollection[];
}
export const HelpCollectionCards = ({ collections }: Props) => {
  const { t } = useTranslation();
  return (
    <Box className={"bg-dark/5 rounded-lg p-4.5"}>
      <Box className={"grid-cols-3 gap-(--gap-md) grid"}>
        {collections.map((collection, index) => (
          <Link key={`article-${collection.id}-${index}`} to={`/help/collection/${collection.id}`}>
            <Stack
              direction={"vertical"}
              justify={"between"}
              items={"center"}
              gap={"xl"}
              className={twMerge(
                "w-full bg-light  rounded-lg p-4.5",
                "hover:bg-dark/10 cursor-pointer h-full"
              )}
            >
              <Stack className={"w-full h-full"}>
                {collection.emoji && (
                  <Box className={"mb-6"}>
                    <Avatar size={"xl"} emoji={collection.emoji} />
                  </Box>
                )}
                <Title header={collection.title} caption={collection.description} />
              </Stack>
              <Tag
                variant={"secondary"}
                // rightIcon={<FontAwesomeIcon icon={"fa-light fa-chevron-right"} />}
                className={"self-end shrink-0"}
                // href={`/help/collection/${collection.id}`}
              >
                {t("plurals:articles_count", { count: collection.articleCount })}
              </Tag>
            </Stack>
          </Link>
        ))}
      </Box>
    </Box>
  );
};
